window.site = (window.site || {});

/**
 * Init script
 * @class Site
 * @static
 */
site.Soumissions = (function Soumissions() {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    // Detect css-grid un-supported
    const el = document.createElement("div")
    const supportsGrid = "string" == typeof el.style.grid;
    if(!supportsGrid) {
      return false;
    }

    // IE 11 || Old Browser - Ignore zone

    inited = true;

    if (!document.querySelector('.add-more')) {
      return false;
    }

    var adder = document.querySelector('.add-more');
    var uploader = [].slice.call(document.querySelectorAll('.upload-item'));

    adder.addEventListener('click', function(e) {
      e.preventDefault();

      adder.style.display = 'none';

      uploader.forEach(function(elem) {
        elem.removeAttribute('style');
      });

      site.GSAPAnims.refreshScroll();
    });

    return true;
  };

  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
